export default [
  { name: 'Institution', prop: 'member_id', type: 'autocomplete', references: 'admin/institutions', referenceProp: 'name', disabled: true },
  { name: 'Membership Plan', prop: 'membership_plan_id', type: 'autocomplete', references: 'admin/membership_plans', referenceProp: 'name', disabled: true },
  { name: 'Activation Date', prop: 'activated_at', type: 'date' },
  { name: 'Expires', prop: 'expires_at', type: 'date' },
  { name: 'Last Renewal Date', prop: 'renewed_at', type: 'date' }
]
